import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { DetailList, DetailRow } from "@/components/detail-list";
import { PageHeader } from "@/components/layout/page-header";
import { useUserQuery } from "@/hooks/use-user";

export function AccountSettingsPage() {
  const { data: user } = useUserQuery();

  // Some accounts carry their email as their name; showing it once is enough.
  const rawName = user?.name?.trim();
  const name = rawName && rawName !== user?.email ? rawName : undefined;

  return (
    <div className="flex flex-1 flex-col gap-6">
      <PageHeader title="Account" />
      <Card className="mx-auto w-full max-w-3xl">
        <CardHeader>
          <CardTitle>User Details</CardTitle>
        </CardHeader>
        <CardContent>
          <DetailList>
            {name && <DetailRow label="Name">{name}</DetailRow>}
            {user?.email && <DetailRow label="Email">{user.email}</DetailRow>}
          </DetailList>
        </CardContent>
      </Card>
    </div>
  );
}
